import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as commonActions from './app-store/common-store/common.actions';
import { CommonState } from './app-store/common-store/common.state';
import * as appRootActions from './app-store/my-modules-store/actions/app-root/app-root.actions';
import { MyModulesState } from './app-store/my-modules-store/my-modules.reducer';
import * as selectors from './app-store/my-modules-store/my-modules.selectors';

@Injectable({
    providedIn: 'root',
})
export class AppFacadeService {
    myModulesTotalCount$ = this.myModulesStore$.select(selectors.selectMyModulesTotalCount);

    constructor(
        private myModulesStore$: Store<MyModulesState>,
        private commonStore$: Store<CommonState>,
    ) {}

    reloadMyModules(): void {
        this.myModulesStore$.dispatch(appRootActions.loadMyModules({ isReloadEnforced: true }));
    }

    loadModulesTotalCount(): void {
        this.myModulesStore$.dispatch(appRootActions.loadMyModulesTotalCount());
    }

    loadSystemModules(): void {
        this.commonStore$.dispatch(commonActions.loadSystemModules());
    }

    loadSegmentationWorkflows(): void {
        this.commonStore$.dispatch(commonActions.loadSegmentationWorkflows());
    }

    loadTrainingWorkflows(): void {
        this.commonStore$.dispatch(commonActions.loadTrainingWorkflows());
    }
}
